let baseUrl = 'http://62.61.8.56:90/flowable-rest';
let runtimeUrl = '/service/runtime';
let options = {baseUrl, credentials: 'same-origin', mode: 'no-cors'};

/** Параметр, содержащий подключение к REST сервиса FLOWABLE */
const bpmn_rest_endpoint_url = "bpmn.rest.endpoint.url";
/** Параметр, содержащий идентификатор элемента в DOM c настройками */
const id_settings = "settings";

/** В HTML странице должен быть элемент с id_settings в котором атрибут bpmn_rest_endpoint_url содержит адрес REST API Flowable
 *  например  <div class="display: none;" id="settings" bpmn.rest.endpoint.url="http://62.61.8.56:90/flowable-rest"></div>
 */
const loadFlowableSettings = settings =>{
	const node = document.getElementById(id_settings);
	if (!node){
		alert("Параметры соединения c бизнес-процессами отсутствуют!\nБудут использованы встроенные настройки!\nОбратитесь к администратору системы.")
		return;
	}
    settings.baseUrl = node.getAttribute(bpmn_rest_endpoint_url);
	return settings;
}

if (process.env.NODE_ENV === 'development') {
    //Режим разработки подключается к 62.61.8.56:8080 (Liferay экспертной системы) //rtn-dev.imik.tech:8080
    baseUrl = 'http://62.61.8.56:90/flowable-rest';
    runtimeUrl = 'http://62.61.8.56:90/flowable-rest/service/runtime';
    options.credentials = 'include';
    options.mode='cors';
    options.baseUrl = baseUrl;
    console.log("flowable settings development", runtimeUrl, options);
}

let settings = loadFlowableSettings({
    apiUri: baseUrl,
    timeout: 300000,
    DATE_TIME_FORMAT: 'DD.MM.YYYY HH:mm',
    DATE_FORMAT: 'DD.MM.YYYY',
    defaultLocale: 'ru',
    auth: {
        username: 'admin',
        password: 'test'
    },
    defaultLimit: 10,
}); 

export default settings;
